import React from "react";
import {
  Flip,
  NotInterested,
  Rotate90DegreesCcw,
  Rotate90DegreesCw,
} from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  FormControlLabel,
  MenuItem,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { usePlayerActions } from "../../../actions";
import type { InitializedPanelNode } from "../../../panels";
import { FlipDirection, RotationDirection } from "../../../panels";

export function ImageTransformControls({
  panel,
  flipDirection,
}: {
  panel: InitializedPanelNode;
  flipDirection: FlipDirection | null;
}) {
  const playerActions = usePlayerActions();

  function handleToggleColorization(e: React.ChangeEvent<HTMLInputElement>) {
    playerActions.toggleImageColorization(panel, e.target.checked);
  }

  function createRotationHandler(direction: RotationDirection) {
    return function handleRotate() {
      playerActions.rotateImage(panel, direction);
    };
  }

  function handleChangeFlipDirection(e: React.ChangeEvent<HTMLInputElement>) {
    const flipDirection =
      e.target.value === "null" ? null : (e.target.value as FlipDirection);

    playerActions.flipImage(panel, flipDirection);
  }

  return (
    <>
      <Typography variant="h6" component="p" sx={{ mb: 2 }}>
        Image Effects
      </Typography>
      <Typography>Rotate</Typography>
      <ButtonGroup
        fullWidth
        disableElevation
        variant="contained"
        color="primary"
      >
        <Button
          startIcon={<Rotate90DegreesCcw />}
          onClick={createRotationHandler(RotationDirection.Left)}
        >
          Left
        </Button>
        <Button
          startIcon={<Rotate90DegreesCw />}
          onClick={createRotationHandler(RotationDirection.Right)}
        >
          Right
        </Button>
      </ButtonGroup>
      <TextField
        sx={{
          my: 2,
          "& .MuiStack-root": {
            alignItems: "center",
            gap: 0.5,
          },
        }}
        select
        SelectProps={{
          MenuProps: {
            sx: {
              "& .MuiStack-root": {
                alignItems: "center",
                gap: 0.5,
              },
            },
          },
        }}
        fullWidth
        label="Flip"
        value={String(flipDirection)}
        onChange={handleChangeFlipDirection}
      >
        <MenuItem value="null">
          <Stack direction="row">
            <NotInterested />
            None
          </Stack>
        </MenuItem>
        <MenuItem value={FlipDirection.X}>
          <Stack direction="row">
            <Flip />
            Horizontal
          </Stack>
        </MenuItem>
        <MenuItem value={FlipDirection.Y}>
          <Stack direction="row">
            <Flip sx={{ rotate: "90deg" }} />
            Vertical
          </Stack>
        </MenuItem>
      </TextField>
      <FormControlLabel
        sx={{ justifyContent: "space-between", ml: 0 }}
        control={
          <Switch
            checked={panel.colorizeImage}
            onChange={handleToggleColorization}
          />
        }
        label="Colorize"
        labelPlacement="start"
      />
    </>
  );
}
